import { render, staticRenderFns } from "./CheckoutWizard.vue?vue&type=template&id=518ae9c0&scoped=true"
import script from "./CheckoutWizard.vue?vue&type=script&lang=ts"
export * from "./CheckoutWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ae9c0",
  null
  
)

export default component.exports